import { useState } from "react";
import styled from "styled-components";

const ToggleWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  height: 52px;
  position: relative;

  .toggle-background {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 8px 8px 0 0;
    border: 1.5px solid #dcdee3;
    border-bottom: 0;
  }
`;

const ToggleItem = styled.div`
  z-index: 10;
  box-sizing: border-box;
  font-family: Pretendard;
  font-size: 15px;
  line-height: 17.9px;
  text-align: center;
  border-radius: 8px 8px 0 0;

  font-weight: ${(props) => (props.$active ? "600" : "400")};

  display: flex;
  align-items: center;
  justify-content: center;

  color: ${(props) => (props.$active ? "#000000" : "#969799")};
  cursor: pointer;
  border: 1.5px solid transparent; // 기본 테두리 설정
  border-bottom: 1.5px solid #000000; // 기본 하단 테두리

  ${(props) =>
    props.$active &&
    `
    border-color: #000000;
    border-bottom-color: #ffffff;
  `}

  flex: 1;
`;

const AlphaTradeListToggle = ({
  setToggleState,
  tabNames = ["알파노트 추천", "스타일별 랭킹", "리그별 랭킹"],
  toggleState = ["recommend", "style", "league"],
  type = "recommend",
}) => {
  const givenIndex = toggleState.findIndex((state) => state === type);
  const [activeIndex, setActiveIndex] = useState(
    givenIndex === -1 ? 0 : givenIndex
  );

  return (
    <ToggleWrapper>
      <div className="toggle-background" />
      {tabNames.map((item, index) => (
        <ToggleItem
          key={index}
          $active={index === activeIndex}
          onClick={() => {
            setActiveIndex(index);
            setToggleState(toggleState[index]);
          }}
        >
          {item}
        </ToggleItem>
      ))}
    </ToggleWrapper>
  );
};

export default AlphaTradeListToggle;
